export class NextPanel {
	nextPanel: NextPanelValue;
	message: string;
	version: string;

	constructor() {
		this.nextPanel = new NextPanelValue();
		this.message = null;
		this.version = null;
	}
}

export class NextPanelValue {
	value: string;

	constructor() {
		this.value = null;
	}
}
